// Ana sayfa "Personel Performansı - Aylık Görevler" yığılmış çubuk grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.monthlyPersonnelPerformance';

export const monthlyPersonnelPerformanceGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Personel Performansı - Aylık Görevler nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, personelin aylık görevlerdeki performansını gösterir. Her yatay çubuk bir personeldir ve personelin tamamladığı, devam eden ve kaçırdığı görev sayısından oluşur. En çok görevi olan ilk 5 personel, toplam görev sayısına göre çoktan aza sıralanır. Çubuk parçalarının içindeki sayılar görev adedidir; çubuğun üzerine gelince üç sayıyı birlikte görürsünüz.'),
  chart: {
    kind: 'stacked',
    legend: [
      { color: '#4CAF50', label: t(`${G}.l1.label`, 'Tamamlanan'), text: t(`${G}.l1.text`, 'Personelin başarıyla tamamladığı aylık görevlerin sayısı. Her tamamlanma kaydı ayrı sayılır.') },
      { color: '#1976D2', label: t(`${G}.l2.label`, 'Devam Eden'), text: t(`${G}.l2.text`, 'Personelin kabul ettiği ve şu an üzerinde çalıştığı etkin aylık görevlerin sayısı.') },
      { color: '#F44336', label: t(`${G}.l3.label`, 'Kaçırılan'), text: t(`${G}.l3.text`, 'Personelin zamanında tamamlayamadığı aylık görevlerin sayısı.') },
    ],
    note: t(`${G}.note`, 'Hiç görevi olmayan personel grafikte görünmez.'),
  },
});
